import { formatDate } from '@/utils/format'

export function computeSolarNoon(date, sunriseTime, sunsetTime) {
    function parseMin(str) {
        const lower = str.toLowerCase().trim()
        const isPm  = lower.includes('pm')
        const isAm  = lower.includes('am')
        const clean = lower.replace(/[apm\s]/g, '')
        let [h, m]  = clean.split(':').map(Number)
        if (isPm && h !== 12) h += 12
        if (isAm && h === 12) h = 0
        return h * 60 + (m || 0)
    }
    const noonMin = Math.round((parseMin(sunriseTime) + parseMin(sunsetTime)) / 2)
    const h = String(Math.floor(noonMin / 60)).padStart(2, '0')
    const m = String(noonMin % 60).padStart(2, '0')
    return `${formatDate(date)} ${h}:${m}:00`
}

export function minToTimeStr(min) {
    const m = ((min % 1440) + 1440) % 1440
    const h = Math.floor(m / 60)
    const mm = m % 60
    const period = h >= 12 ? 'pm' : 'am'
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h
    return `${h12}:${String(mm).padStart(2, '0')} ${period}`
}
